import { useMemo } from 'react';

import { createUnsafeLinkPath, useCurrentRoute } from '@luna/router';

import type { MenuItem } from './typing';

export function useSideMenuNavigation(menuItems: MenuItem[], activeMenuItem?: string): MenuItem {
    const currentRoute = useCurrentRoute();

    return useMemo(
        () =>
            menuItems.find((navigationItem) => {
                if (activeMenuItem) {
                    return navigationItem.id === activeMenuItem;
                }
                return createUnsafeLinkPath(currentRoute).includes(
                    createUnsafeLinkPath(navigationItem.href),
                );
            }) ?? ({} as MenuItem),
        [menuItems, currentRoute],
    );
}
